
export const navigationThai = {
    lang: 'th',
    data: {
        NAV: {
            HOME: 'หน้าหลัก',
            MANAGE_BILL: 'จัดการบิล',
            ACCOUNTING: 'บัญชี',
            SAVE_DAY: 'บันทึกประจำวัน',
            SALE: 'ขายสินค้า',
            RETURN: 'รับคืนสินค้า',
            MEMBER: 'สมาชิกร้าน',
            PAYMENT_TYPE: 'ประเภทค่าใช้จ่าย',
            PAYMENT: 'บันทึกค่าใช้จ่าย',
            QTT: 'ใบเสนอราคา',
            PO: 'ใบสั่งซื้อ (PO)',
            COUPON: 'คูปองส่วนลด',
            SET_MEMBER_POINT: 'กำหนดคะแนนสมาชิก',
            MEMBER_POINT: 'แต้มสมาชิก',
            PRICE_GROUP: 'ราคาแบบเหมา',
            REPORT: 'รายงาน',
            FREE_PROMOTION : 'สินค้าแถม (5 แถม 1)',
            PROMOTION_SET: 'ชุดเซ็ตโปรโมชั่น',
            REPORT_AR: 'รายงานลูกหนี้',
            REPORT_SALE: 'รายงานยอดขายรายวัน',
            REPORT_STOCK: 'รายงานสต๊อกสินค้า',
            REPORT_CDT: 'รายงานเจ้าหนี้',
            REPORT_EX: 'รายงานสินค้าหมดอายุ',
            REPORT_PL: 'รายงานกำไรขาดทุน',
            REPORT_SPD: 'สรุปยอดขายรายวัน',
            REPORT_SPCH: 'สรุปยอดตามช่องทางจำหน่าย',
            REPORT_SPPAY: 'สรุปยอดตามช่องทางชำระ',
            REPORT_SPM: 'สรุปยอดขายรายเดือน',
            REPORT_SPMEM: 'ยอดขายตามสมาชิก',
            REPORT_USER_SALE: 'ยอดขายตามพนักงาน',
            REPORT_SALE_CATEGORY: 'รายงานยอดขายตามสินค้า',
            REPORT_SALE_DETAITL: 'รายละเอียดการขาย',
            REPORT_STOCK_HIS: 'ความเคลื่อนไหวสต้อก',
            SET_MENU_FOR_USE: 'สิทธิการเข้าใช้งาน',
            SET_RUNNING_BILL: 'รูปแบบการรันเลขเอกสาร',
            SET_PRINT_BILL: 'ตั้งค่าการพิมพ์บิล',
            SET_BILL_AND_LESS_QTY: 'ตั้งค่าบิลและสินค้าขั้นต่ำ',
            SALE_CONDITION: 'เงื่อนไขการขายสินค้า',
            STOCK: 'สต๊อกสินค้า',
            IMPORT_ST: 'รับสินค้าเข้าสต้อก',
            ADJUST_ST: 'ปรับยอดสต๊อก',
            REQUES_ST: 'เบิกสินค้า',
            RESIVE_ST: 'รับสินค้า',
            TRANSFER_ST: 'โอนสินค้า',
            SETTING: 'ตั้งค่าพื้นฐาน',
            SYSTEM: 'ตั้งค่าระบบ',
            ST_COMPANY: 'ตั้งค่าข้อมูลร้าน',
            ST_DOC: 'ตั้งค่าเอกสาร',
            ST_EXCHANGE: 'อัตราแลกเปลียน',
            ST_BRANCH: 'คลังสินค้า/สาขา',
            ST_USER: 'ผู้ใช้งานระบบ',
            ST_CREDITOR: 'คู่ค้า',
            ST_PRODUCT: 'สินค้า',
            ST_PRICE: 'ราคาจำหน่าย',
            ST_SUPLIER: 'ผู้จำหน่ายสินค้า',
            ST_CHANELSALE: 'ช่องทางจำหน่าย',
            ST_CHANELPAYMENT: 'ช่องทางชำระเงิน',
            ST_PD_TYPE: 'ประเภทสินค้า',
            ST_PAY_TYPE: 'ประเภทค่าใช้จ่าย',
            ADD_PAY_TYPE: 'เพิ่มประเภทค้าใช้จ่าย',
            ADD_PD_TYPE: 'เพิ่มประเภทสินค้า',
            ST_NPD_TYPE: 'ชื่อประเภท',
            ST_ADD_CREDITOR: 'คู่ค้า',
            ST_ADD: 'เพิ่ม',
            SELECT_CTM: 'เลือกลูกค้า',
            SELECT_PD: 'เลือกสินค้า',
            PROMOTION : 'ส่งเสริมการขาย',
            COMPANY_ASSETS : 'ทรัพย์สินของบริษัท',
            QUARTER: 'รายได้ตามไตรมาส',
            MANAGE_PAGE: {
                ALL: 'ทั้งหมด',
                BILL_DETAIL: 'รายละเอียดบิล',
                SEND_BILL: 'บิลส่งสินค้า',
                EDIT_BILL: 'แก้ไขบิล',
                CTM_BRANCH: 'สมาชิกสาขา',
                Delivery_Cover: 'ใบประหน้า',
                TABLE: {
                    BILL_ID: 'เลขบิล',
                    PAY_DATE: 'วันที่จ่าย',
                    CREATED_DATE: 'วันที่ออกบิล',
                    SUM_SALE: 'รวมยอดขาย',
                    DISCOUNT: 'ส่วนลด',
                },
            },
            SALE_PAGE: {
                BTN_TEXT: {
                    PAUSE_BILL: 'พักบิล',
                    CLEAN: 'เคลียร์รายการทั้งหมด',
                    END_SALE: 'จบการขาย',
                    END_SALE_AND_PAY: 'จ่ายพอดีและจบการขาย',
                    Cancel_BILL: 'ยกเลิกพักบิล',
                    Bill_Sale: 'พิมพ์บิลล่าสุด',
                },
                USER_SALE: 'พนักงานขาย',
                SELECT_SALE_PATTERN: {
                    SALE_PATTERN: 'รูปแบบการขาย',
                    RETAIL: 'ขายปลีก',
                    WHOLESALE: 'ขายส่ง',
                },
                QTY: 'จำนวน',
                LIST_PRODUCT: 'รายการสินค้า',
                TABLE: {
                    PICTURE: 'รูปภาพ',
                    PRODUCT: 'สินค้า',
                    PRICE: 'ราคา',
                    DELETE: 'ลบ',
                    KIP: 'กีบ',
                },
                DIALOG: {
                    FORM_CUSTOMER: {
                        H_CUSTOMER: 'ลูกค้า',
                        NAME_CUT: 'ชื่อลูกค้า',
                        ID_TAXPAYER: 'เลขผู้เสียภาษี',
                        PHONE: 'เบอร์โทร',
                        ADDRESS: 'ที่อยู่',
                    },
                    FORM_END_SALE: {
                        CREATION_DATE: 'วันที่ทำรายการ',
                        MONEY_cash: 'เงินสด',
                        MONEY_CREDIT: 'เงินเชื่อ',
                        PRINT: {
                            H_PRINT: 'พิมพ์',
                            SLIP: 'สลีป',
                        },
                        PAY_CANNEl: 'ช่องทางจำหน่าย',
                        HOME_SHOP: 'หน้าร้าน',
                        DISCOUNT_BILL: 'ส่วนลดบิล',
                        SUM_DISCOUNT: 'ยอดเงินคำนวน',
                    },
                    FORM_MONEY: {
                        SUM_BILL: 'ยอดเงิน',
                        MONEY_PAID: 'ยอดเงินที่จ่าย',
                        DEPOSIT_RECEIVE: 'รับเงิน/มัดจำ',
                        EX_CHANG: 'เงินทอน',
                    },
                    Pay_exactly: 'จ่ายพอดี',
                },
            },
            MEMBER_PAGE: {
                TABLE: {
                    CODE: 'รหัสสมาชิก',
                    NAME: 'ชื่อสมาชิก',
                    TEL : 'เบอร์โทร',
                },
                DIALOG: {
                    BRANCH_REGIS: 'สาขาที่สมัคร',
                    TAX_ID : 'เลขผู้เสียภาษี',
                    MEMBER_TYPE: 'ประเภทสมาชิก',
                    RATE_PRICE : 'เรทราคาเวลาซื้อ',
                    USER : 'พนักงานขาย',
                    PAYMENT : 'รูปแบบการชำระ',
                    CREDIT_DAY : 'เครดิต (วัน)',
                    CASH : 'เงินสด',
                    CREDIT : 'เงินเชื่อ',
                    DETAIL : 'รายละเอียดเพิ่มเติม',

                },
            },
            PAY_PAGE: {
                LIST: 'รายการ',
                SUM: 'รวม',
                ADD_PAY: 'เพิ่มค่าใช้จ่าย',
                EDIT_PAY: 'แก้ไขค่าใช้จ่าย',
                SELECT_PAY_TYPE: 'กรุณาเลือกประเภทค่าใช้จ่าย',
            },
            QTT_PAGE: {
                ADD_QTT: 'เพิ่มใบเสนอราคา',
                ALL_QTT: 'ใบเสนอราคาทั้งหมด',
                SHOW_QTT: 'แสดงข้อมูลใบเสนอราคา',
                EDIT_QTT: 'แก้ไขใบเสนอราคา',
                PRINT_QTT: 'พิมพ์ใบเสนอราคา',
                DIALOG: {
                    MEMBER: 'ข้อมูลลูกค้า',
                },
                PRINT: {
                    SUM_TOTAL: 'ยอดรวมสุทธิ',
                    NAME_QTT: 'ชื่อผู้เสนอราคา',
                    SIGN: 'ลงชื่อ',
                    QTT_MEMBER: 'ผู้ตกลงราคา',
                    QTT_USER: 'ผู้เสนอราคา',
                },
            },
            COUPON_PAGE: {
                ADD_COUPON: 'เพิ่มคูปองส่วนลด',
                EDIT_COUPON: 'แก้ไขคูปองส่วนลด',
                SHOW_COUPON: 'รายละเอียดคูปอง',
                MONEY_COUPON: 'เงินในคูปอง',
                EXPIRE_COUPON: 'วันหมดอายุ',
                REMARK_STAR: 'ตารางสินค้าที่มีพื้นหลังสีแดง',
                REMARK_EXPIRE: 'คูปองหมดอายุ',
                PRINT_COUPON: 'พิมพ์คูปองส่วนลด',
                MONEY_IN_COUPON: 'จำนวนเงินในคูปอง',
            },
            MEMBER_POINT_PAGE: {
                NUMBER_POINT_KIP: 'จำนวน X กีบ = 1 แต้ม',
                KIP_QTY: 'จำนวนกีบ',
            },
            REPORT_AR_PAGE: {
                PAY_SUCCESS: 'จ่ายสำเร็จ',
                NO_PAY: 'ยังไม่จ่าย',
                DEPOSIT: 'มัดจำ',
                RECEIVE: 'รับเงิน',
                CF_SAVE: 'ยืนยันการชำระ',
                LIST_SUCCESS: 'ทำรายการสำเร็จ',
                LIST_NOT: 'ทำรายการไม่สำเร็จ',
            },
            REPORT_SALE_PAGE: {
                BILL_ID: 'เลขที่บิล',
                PAYMENT: 'การชำระเงิน',
            },
            REPORT_STOCK_PAGE: {
                BEFORE: 'ก่อน',
                AFTER: 'หลัง',
                TF_OUT: 'โอนออก',
                TF_COME: 'โอนมา',
                AdjustQty: 'ยอดปรับ',
                Remaining: 'จำนวนคงเหลือ',
                Value: 'มูลค่าคงคลัง'
            },
            REPORT_CDT_PAGE: {
                IMPORT_DATE: 'วันที่รับเข้า',
                DATA: 'ข้อมูล',
                BUY_FROM: 'ชื้อมาจาก',
            },
            REPORT_EXPIRE_PAGE: {
                TABLE_REMARK: 'ตารางที่มีพื้นหลังสีเหลือง',
                EXPIRE: 'สินค้าหมดอายุ',
                EXPIRE_H: 'หมดอายุภายใน',
                NO_EXPIRE: 'สินค้าไม่มีหมดอายุ',
                EXPIRE_ABOUT: 'สินค้าไกล้หมดอายุ',
            },
            REPORT_PROFIT_PAGE: {
                H_TABLE: {
                    SALES: 'ยอดขาย',
                },
                Income: 'รายได้',
                profit: 'กำไร',
            },
            IMPORT_STOCK: {
                ID_IMPORT: 'เลขที่รับเข้า',
                BILL_IMPORT: 'บิลรับเข้าสินค้า',
            },
            ADJUST_STOCK: {
                ADJ_HITORY: 'ประวัติปรับสต๊อก',
            },
            TRANSFER_STOCK: {
                TF_HITORY: 'ประวัติการโอนสินค้า',
                FORM_BRANCH: 'จากสาขา',
                TO_BRANCH: 'ไปสาขา',
                TF_CONFRIM: 'ยืนยันการโอนสินค้า',
                TF_DETAIL: 'รายละเอียดการโอนสินค้า',
                NUMBER_TF: 'เลขที่การโอน',
            },
            COPANY_PAGE: {
                NAME_COPANY: 'ชื่อร้าน',
                UPLOAD_LOGO: 'อัฟโหลดโลโก้ร้าน',
            },
            DOC_SETTING: {
                PAPER_SIZE: 'ขนาดกระดาษ',
                WIDTH_BILL: 'ความกว้างของบิล',
                HEIGHT_BILL: 'ความสูงบิล',
                FONT_SIZE_BILL: 'ขนาดอักษรของบิล',
                LOGO_WIDTH: 'ความกว้างของโลโก้',
                LOGO_HEIGHT: 'ความสูงของโลโก้',
                PAPER_FONT_SIZE: 'ขนาดตัวอักษรกระดาษ',
            },
            EXCHANGE: {
                KEP_PER_BAHT: 'บาท ต่อ กีบ',
                DOLLAR_PER_KIP: 'ดอลลาร์ ต่อ กีบ',
            },
            BRANCH: {
                ADD_BRANCH: 'เพิ่มสาขา',
                EDIT_BRANCH: 'แก้ไขสาขา',
            },
            USER_PAGE: {
                ADD_USER: 'เพิ่มผู้ใช้งาน',
                EDIT_USER: 'แก้ไขผู้ใช้งาน',
                LEVEL: 'ระดับ',
                ADMIN: 'ผู้ดูแลระบบ',
                CASHIER: 'พนักงานขาย',
                STOCK: 'สต๊อก',
                ST_SALE: 'พนักงานขาย+สต๊อก',
                ST_CS_RP: 'พนักงานขาย+สต๊อก+รายงาน'
            },
            FORM_DATE: {
                START_DATE: 'จากวันที่',
                END_DATE: 'ถึงวันที่',
                DATE: 'วันที่',
                DAY: 'วัน',
            },
            PRODUCT: {
                NAME_PD: 'ชื่อสินค้า',
                Total: 'ยอดรวม',
                RRICE_CONST: 'ราคาทุน',
                ADD_PRODUCT: 'เพิ่มสินค้า',
                EDIT_PRODUCT: 'แก้ไขสินค้า',
                ALL_PRODUCT: 'สินค้าทั้งหมด',
                IMPORT_CSV: 'นำเข้าสินค้าจาก CSV',
                EXPORT_CSV: 'ส่งออกสินค้า CSV',
                PRICE_SALE: 'ราคาขาย',
                PRICE_SEND: 'ราคาส่ง',
                PRINT_BC: 'พิมพ์ Barcode',
                LAMP: 'ดวง',
                REMARK_IMPORT: 'เงื่อนไขการนำเข้า',
                NO_IMPORT: 'สินค้าที่บาร์โค้ดซ้ำกัน ระบบจะไม่ทำการนำเข้าเพราะถือว่าเป็นสินค้าที่มีในระบบแล้ว',
                NO_COMMA: 'ในชื่อสินค้าจะต้องไม่มีสัญลักษณ์',
                GEN_BARCODE: 'สร้าง Barcode อัตโนมัติ',
                FAIL_IMPORT: 'พบสินค้าบางตัวไม่สามารถทำรายการได้ โปรดทำรายตรวจสอบรายการ'

            },
            TABLE_ALL: {
                NO: 'เลขที่',
                NAME: 'ชื่อ',
                ADDRESS: 'ที่อยู่',
                'EDIT/DELETE': 'แก้ไข/ลบ',
                REMARK: 'หมายเหตุ',
                EDIT: 'แก้ไข',
                STATUS: 'สถานะ',
                READY_TO_USE: 'พร้อมใช้งาน',
                SELECT: 'เลือก',
                USERNAME: 'ชื่อผู้ใช้',
            },
            BTN_TEXT: {
                SHOW: 'แสดงข้อมูล',
                SHOW_INFO: 'แสดงรายละเอียด',
                ADD: 'เพิ่มรายการ',
                SAVE: 'บันทึก',
                CLOSE: 'ปิด',
                SEARCH: 'ค้นหา',
                SELECT_BRANCH: 'กรุณาเลือกสาขา',
                SELECT_BRANCH2: '-----เลือกสาขา-----',
                YES: 'ตกลง',
                PAY: 'จ่าย',
                LOGIN: 'ออกจากระบบ'
            },
            ERROR: {
                CTM_NAME: 'กรุณากรอก ชื่อลูกค้า',
                CTM_PHONE: 'กรุณากรอก เบอร์โทร',
                CTM_ADDRESS: 'กรุณากรอก ที่อยู่',
                KEY_NAME: 'กรุณากรอกชื่อ',
                KEY_USERNAME: 'กรุณากรอกชื่อผู้ใช้งาน',
                KEY_PASS: 'กรุณากรอกรหัสผ่าน',
                SELECT_LEVEL: 'กรุณาเลือกระดับ',
                PD_NO_INFO: 'ไม่มีข้อมูลสินค้า',
                CANCEL: 'ยกเลิก',
                SUCCESS: 'บันทึกสำเร็จ',
                DELETE: 'ลบสำเร็จ',
                FAIL: 'เกิดข้อผิดพลาด',
                DETAIL: 'รายละเอียด',
                NOT_VALUE: 'ข้อมูลนำเข้าไม่ครบ',
                VALUE_VALIDATE: 'กรุณากรอกข้อมูลให้ครบ',
                PRODUCT_HAVE: 'มีสินค้าในระบบแล้ว',
                CHECK_UPLOAD: 'กรุณาอัฟโหลดรูปภาพก่อน',
                UPLOAD_SUCCESS: 'อัฟโหลดแล้ว',
                SELECT_FILE: 'เลือกไฟล์',
                CHECK_USER: 'มีผู้งานระบบนี้แล้ว',
                KEY_BARCODE: 'กรุณากรอก Barcode',
                KEY_PD_NAME: 'กรุณากรอกชื่อสินค้า',
                KEY_P_CONST: 'กรุณากรอกราคาทุน',
                KEY_P_SALE: 'กรุณากรอกราคาขาย',
                KEY_P_SEND: 'กรุณากรอกราคาส่ง',
                KEY_NUMBER: 'กรุณากรอกตัวเลข',
                SELECT_PD_TYPE: 'กรุณาเลือกประเภทสินค้า',
                NO_BILL_DAY: 'ไม่พบบิลขายล่าสุดของวันนี้',
                CHECK_MONEY: 'ยอดขายเป็น 0 จบการขายไม่ได้',
                NO_PD: 'ไม่มีสินค้า',
                EXPIRE_COMPANY: 'หมดอายุแล้ว กรุณาติดต่อเจ้าหน้าที่ขาย',
                TEL_SERVIECT: 'ติดต่อสอบถามฝ่ายขายบริการที่เบอร์',
                DAY_SERVIEC: 'จันทร์-ศุกร์ เวลา',
                CHECK_MONEY_SUM: 'จ่ายให้มากกว่ายอดที่จ่าย',
                NOCOUPON: 'ไม่มีคูปองส่วนลด',
                CHECK_MEMBER: 'กรุณาใส่ข้อมูลลูกค้าให้ครบ',
                NO_MONEY: 'กรุณาใส่จำนวนเงิน',
                DISCOUNT_KREN: 'ส่วนลดเกินราคาบิล',
                PERSEND: 'ส่วนลดเปอร์เช็นต้องน้อยกว่า 100'
            },
            CONFIRM: {
                TITLE: 'คุณต้องการจะลบ',
                YES_NO: ' ใช่หรือไม่',
                CF_SAVE: 'ยืนยันการบันทึก',
                CF_CLEAN: 'คุณต้องการจะเคลียร์รายการทั้งหมด ใช่หรือไม่',
                CF_CANCEL: 'ยืนยันการยกเลิกพักบิล',
                WARNING_DELETED: 'คำเตือน การลบรายการอาจทำให้เกิดปัญหากับผลการคำนวณในรายงาน'
            },
            SUM_SALE_DAY: 'ยอดขายวันนี้',
            SUM_SALE_MON: 'ยอดขายเดือนนี้'
        },
    },
};

